export const NAV_BYPASS_PREFIXES = [
	'/dashboard',
	'/profile',
	'/notifications',
	'/notification-settings',
	'/logout',
	'/settings',
];

export const checkNavAccess = (pathname, permissions, userRole) => {
	if (userRole === 'admin') return true;

	const cleanPathname = (pathname || '').trim();

	const isBypassed = NAV_BYPASS_PREFIXES.some(
		prefix => cleanPathname === prefix || cleanPathname.startsWith(prefix + '/')
	);
	if (isBypassed) return true;

	if (!permissions?.length) return true;

	return permissions.some(p => {
		let permPath = (p.path || p.to || '').trim();
		if (!permPath) return false;

		// Remove trailing slash from permPath if exists for exact matching
		if (permPath.length > 1 && permPath.endsWith('/')) {
			permPath = permPath.slice(0, -1);
		}

		if (cleanPathname === permPath) return true;
		if (cleanPathname.startsWith(permPath + '/')) return true;

		// Handle cases where the UI route has a prefix not present in the permission path
		// e.g., pathname: "/tickets/123", permPath: "/tickets"
		if (permPath !== '/' && permPath !== '') {
			if (cleanPathname.endsWith(permPath)) return true;
			if (cleanPathname.includes(permPath + '/')) return true;
		}

		return false;
	});
};
